/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'goal-fields.goal-followers.add-followers-title': 'Adicionar seguidores',
  'goal-fields.goal-followers.title': 'Seguidores',
  'goal-fields.goal-links.add-parent-goal-title': 'Adicionar meta pai',
  'goal-fields.goal-links.edit-parent-goal-title': 'Editar meta pai',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Desvincular a meta pai',
  'goal-fields.goal-metrics.automatic-metric-title': 'Das submetas',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Iniciar:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Alvo:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'O preenchimento automático do progresso é feito via {compass}. Essa métrica de meta só pode ser editada em {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Vá para a página completa de metas para alterar este campo',
  'goal-fields.goal-metrics.no-metrics-title': 'Não há métricas',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'progresso feito',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'Nenhuma submeta com métricas conectada',
  'goal-fields.goal-metrics.title': 'Progresso',
  'goal-fields.goal-owner.title': 'Proprietário',
  'goal-fields.goal-start-date.add-start-date-title': 'Adicionar data de início',
  'goal-fields.goal-start-date.cancel-button': 'Salvar',
  'goal-fields.goal-start-date.creation-date': 'Essa meta foi criada em {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Editar data de início da meta',
  'goal-fields.goal-start-date.enter-start-date-title': 'Insira a data de início',
  'goal-fields.goal-start-date.open-calendar-label': 'Abrir o calendário',
  'goal-fields.goal-start-date.title': 'Data de início',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'Em andamento',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'Mais status',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'Qual é o status atual?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Praticar objetivos e resultados-chave? <link>Veja como usar metas para OKRs</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Link de ajuda',
  'goal-fields.goal-status.archived': 'Arquivado',
  'goal-fields.goal-status.at-risk': 'Em risco',
  'goal-fields.goal-status.cancelled': 'Cancelado',
  'goal-fields.goal-status.completed': 'Concluído 🎉',
  'goal-fields.goal-status.edit-status-lozenge': 'Editar status',
  'goal-fields.goal-status.off-track': 'Fora dos trilhos',
  'goal-fields.goal-status.on-track': 'Nos trilhos',
  'goal-fields.goal-status.paused': 'Pausado',
  'goal-fields.goal-status.pending': 'Pendente',
  'goal-fields.goal-status.title': 'Status',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Adicionar submetas',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Desvincular a submeta',
  'goal-fields.goal-tags.add-tags-title': 'Adicionar marcadores',
  'goal-fields.goal-tags.title': 'Marcadores',
  'goal-fields.goal-target-date.title': 'Data-alvo',
  'goal-fields.goal-type.goal': 'Meta',
  'goal-fields.goal-type.key-result': 'Principal resultado',
  'goal-fields.goal-type.objective': 'Objetivo',
  'goal-fields.goal-type.title': 'Tipo',
  'goal-fields.parent-goal.title': 'Meta pai',
  'goal-fields.sub-goals.title': 'Submetas',
  'goal-fields.teams.add-teams-title': 'Adicionar equipes',
  'goal-fields.teams.follow-team': 'Seguir equipe',
  'goal-fields.teams.remove-team': 'Remover equipe',
  'goal-fields.teams.search-team-placeholder': 'Equipe de pesquisa',
  'goal-fields.teams.show-more': 'Mostrar mais',
  'goal-fields.teams.title': 'Equipes',
  'goal-fields.teams.verified-team-label': 'Equipe verificada',
  'goal-fields.teams.view-profile': 'Visualizar perfil',
  'goal-fields.use-goal-flags.generic-error-description': 'Algo deu errado, tente de novo em alguns minutos.',
  'goal-fields.use-goal-flags.generic-error-title': 'Algo deu errado',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Não foi possível alterar o proprietário da meta',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': 'Não foi possível adicionar o marcador',
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': 'Não foi possível criar o marcador',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': 'Não foi possível remover o marcador',
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': 'Erro ao adicionar equipe. Tente outra vez',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': 'Erro ao remover equipe. Tente outra vez',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Não foi possível alterar a meta do pai',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Não foi possível alterar a data de início',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Não foi possível alterar a data prevista',
  'townsquare.goal-fields.tag': 'Remover marcador',
  'townsquare.goal-fields.tooltip-usage-count':
    '{usageCount, plural, one {Usado em {usageCount,number} local} other {Usado em {usageCount,number} locais}}',
};
